export const LOCAL_SWITCH_COOKIE = "mira-local-switch";
export const LOCAL_SWITCH_PARAM = "mira-local-switch";
export const LIVE_ORIGIN = "https://mira.fans";
export const LOCAL_ORIGIN = "http://localhost:4000";

export function environmentSwitchTarget(url: URL, enabledOnLive: boolean) {
  const local = url.protocol === "http:" && url.port === "4000"
    && (url.hostname === "localhost" || url.hostname === "127.0.0.1");
  const live = url.origin === LIVE_ORIGIN && (enabledOnLive || url.searchParams.get(LOCAL_SWITCH_PARAM) === "1");
  if (!local && !live) return null;
  const target = new URL(local ? LIVE_ORIGIN : LOCAL_ORIGIN);
  target.pathname = url.pathname;
  target.search = url.search;
  target.hash = url.hash;
  target.searchParams.delete(LOCAL_SWITCH_PARAM);
  if (local) target.searchParams.set(LOCAL_SWITCH_PARAM, "1");
  return target.href;
}
